import { createContext, useContext, useState, useEffect } from 'react';
import ConfigurationApiClient from '../../api/configurationApiClient';

const LogoContext = createContext();

export const useLogo = () => {
    const context = useContext(LogoContext);
    if (!context) {
        throw new Error('useLogo must be used within LogoProvider');
    }
    return context;
};

export const LogoProvider = ({ children }) => {
    const [logoUrl, setLogoUrl] = useState(null);
    const [loading, setLoading] = useState(true);

    const loadLogo = async () => {
        try {
            const response = await ConfigurationApiClient.fetchConfigurationByKey("logo");
            if (response.data && response.data.configValue) {
                const logoData = JSON.parse(response.data.configValue);
                if (logoData.logoType === "uploaded" && logoData.logoData) {
                    setLogoUrl(logoData.logoData);
                } else if (logoData.logoType === "url" && logoData.logoUrl) {
                    setLogoUrl(logoData.logoUrl);
                } else {
                    setLogoUrl(null);
                }
            } else {
                setLogoUrl(null);
            }
        } catch (error) {
            console.log("Logo configuration not found");
            setLogoUrl(null);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadLogo();
    }, []);

    const refreshLogo = () => {
        loadLogo();
    };

    return (
        <LogoContext.Provider value={{ logoUrl, loading, refreshLogo }}>
            {children}
        </LogoContext.Provider>
    );
};

